import { NextTable } from '@core/table';

import { useBranchInspectionsTable } from '../hooks';
import { BranchInspectionsTableContext } from '../contexts';

export const BranchInspectionsTable = () => {
  const { columns, getRowProps } = useBranchInspectionsTable();

  return <NextTable context={BranchInspectionsTableContext} sortable={true} filterable={true} columns={columns} getRowProps={getRowProps} />;
};
